export const ROUTES = {
	HOME: '' as const,
	GAME: 'game' as const,
	RULES: 'rules' as const,
	SETTINGS: 'settings' as const,
	ABOUT: 'about' as const
};

export type InternalRoute = (typeof ROUTES)[keyof typeof ROUTES];
